/** Navigation presentation only. Workflow requirements and commands are read by the task panel. */
export interface HearingTaskProgress {
  state: "complete" | "in-progress" | "not-started" | "unavailable" | "optional";
  label: string;
  detail: string;
  criteria?: { label: string; satisfied: boolean }[];
}

/** Legacy record sections have no registered requirement-to-section mapping. */
export const UNKNOWN_TASK_PROGRESS: HearingTaskProgress = {
  state: "unavailable",
  label: "Status unavailable",
  detail: "No workflow requirement mapping is configured for this record section.",
};
